import { ExternalLink } from "lucide-react";
import { trpc } from "@/lib/trpc";
import { Chip } from "@/components/ui/chip";
import { ProviderIcon } from "@/components/workflow/workflow-rail";
import { linkNoun, linkStateChip } from "@/components/workflow/workflow-labels";

interface WalkthroughLinkedIssuesProps {
  canonicalId?: string | null;
}

export function WalkthroughLinkedIssues({
  canonicalId,
}: WalkthroughLinkedIssuesProps) {
  const { data: workflowData } = trpc.workflow.get.useQuery(
    { canonicalId: canonicalId! },
    { enabled: !!canonicalId, staleTime: 30_000 },
  );
  const links = workflowData?.links ?? [];
  if (links.length === 0) return null;

  return (
    <div className="flex flex-wrap items-center gap-2 w-full pb-1">
      {links.map((link) => {
        const chip = linkStateChip(link);
        return (
          <a
            key={link.id}
            href={link.url ?? undefined}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-1.5 rounded-md border border-border bg-card px-2.5 py-1 text-xs font-medium hover:bg-muted transition-colors"
          >
            <ProviderIcon provider={link.provider} className="size-3.5" />
            <span>
              {linkNoun(link.kind)} {link.displayKey ?? ""}
            </span>
            <Chip tone={chip.tone} className="text-2xs py-0 px-1.5 h-4">
              {chip.label}
            </Chip>
            {link.url && (
              <ExternalLink className="size-3 text-muted-foreground" />
            )}
          </a>
        );
      })}
    </div>
  );
}
